document.documentElement.classList.remove('no-js');

const themeSettings = window.themeSettings || {};
const cartDrawer = document.querySelector('[data-cart-drawer]');
const cartBody = document.querySelector('[data-cart-drawer-body]');
const siteHeader = document.querySelector('[data-header]');

const uiText = {
  emptyCart: 'Tu carrito está vacío.',
  decreaseQuantity: 'Reducir cantidad',
  increaseQuantity: 'Aumentar cantidad',
  quantity: 'Cantidad',
  remove: 'Eliminar',
  subtotal: 'Subtotal',
  checkout: 'Finalizar compra',
  updateError: 'No se ha podido actualizar el carrito',
  addError: 'No se ha podido añadir el producto al carrito'
};

function updateHeaderState() {
  if (!siteHeader) return;
  const transparent = siteHeader.dataset.transparent === 'true';
  const scrolled = window.scrollY > 24;
  siteHeader.classList.toggle('header--scrolled', transparent && scrolled);
  siteHeader.classList.toggle('header--solid', !transparent || scrolled);
  siteHeader.classList.toggle('header--transparent', transparent && !scrolled);
}

updateHeaderState();
window.addEventListener('scroll', updateHeaderState, { passive: true });
window.addEventListener('resize', updateHeaderState);
window.addEventListener('pageshow', updateHeaderState);

if (siteHeader) {
  siteHeader.addEventListener('pointerenter', () => {
    siteHeader.classList.add('header--hover');
  });

  siteHeader.addEventListener('pointerleave', () => {
    siteHeader.classList.remove('header--hover');
    updateHeaderState();
  });

  siteHeader.addEventListener('focusin', () => {
    siteHeader.classList.add('header--hover');
  });

  siteHeader.addEventListener('focusout', () => {
    window.setTimeout(() => {
      if (!siteHeader.contains(document.activeElement)) {
        siteHeader.classList.remove('header--hover');
        updateHeaderState();
      }
    }, 0);
  });
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function formatMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'EUR';
  const locale = document.documentElement.lang || 'es-ES';
  return (Number(cents || 0) / 100).toLocaleString(locale, {
    style: 'currency',
    currency
  });
}

function setCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach((node) => {
    node.textContent = String(count || 0);
  });
}

function openCart() {
  if (themeSettings.cartDrawerEnabled === false) {
    window.location.href = '/cart';
    return;
  }
  cartDrawer?.setAttribute('aria-hidden', 'false');
}

function closeCart() {
  cartDrawer?.setAttribute('aria-hidden', 'true');
}

async function fetchCart() {
  const response = await fetch('/cart.js', {
    headers: { Accept: 'application/json' }
  });
  if (!response.ok) throw new Error('Unable to load cart');
  return response.json();
}

function renderCart(cart) {
  setCartCount(cart.item_count);
  if (!cartBody) return;

  if (!cart.items.length) {
    cartBody.innerHTML = `<p class="cart-empty">${uiText.emptyCart}</p>`;
    return;
  }

  const lines = cart.items.map((item) => `
    <div class="cart-line" data-key="${escapeHtml(item.key)}">
      <div>
        <a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
        ${item.variant_title ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
        <p>${formatMoney(item.final_line_price)}</p>
      </div>
      <quantity-input class="quantity">
        <button type="button" name="minus" data-cart-quantity="-1" aria-label="${uiText.decreaseQuantity}">-</button>
        <input type="number" min="0" value="${item.quantity}" aria-label="${uiText.quantity}">
        <button type="button" name="plus" data-cart-quantity="1" aria-label="${uiText.increaseQuantity}">+</button>
      </quantity-input>
      <button type="button" class="link" data-cart-remove>${uiText.remove}</button>
    </div>
  `).join('');

  cartBody.innerHTML = `
    ${lines}
    <div class="cart-subtotal">
      <span>${uiText.subtotal}</span>
      <strong>${formatMoney(cart.total_price)}</strong>
    </div>
    <a class="button button--full" href="/checkout">${uiText.checkout}</a>
  `;
}

async function changeCartLine(key, quantity) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ id: key, quantity })
  });
  if (!response.ok) throw new Error(uiText.updateError);
  renderCart(await response.json());
}

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const input = this.querySelector('input');
        if (!input) return;
        const step = button.name === 'plus' ? 1 : -1;
        input.value = Math.max(Number(input.min || 0), Number(input.value || 0) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
}

customElements.define('quantity-input', QuantityInput);

class VariantSelects extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', () => this.onChange());
  }

  onChange() {
    const script = this.querySelector('script');
    if (!script) return;
    const variants = JSON.parse(script.textContent);
    const options = [...this.querySelectorAll('select')].map((select) => select.value);
    const variant = variants.find((candidate) => candidate.options.every((option, index) => option === options[index]));
    const form = this.closest('form');

    if (variant && form) {
      form.querySelector('[name=id]').value = variant.id;
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  }
}

customElements.define('variant-selects', VariantSelects);

function initSourceSlideshow(slideshow) {
  if (!slideshow || slideshow.dataset.initialized === 'true') return;
  const slides = [...slideshow.querySelectorAll('[data-source-slide]')];
  const dots = [...slideshow.querySelectorAll('[data-source-slide-dot]')];
  if (slides.length <= 1) return;

  slideshow.dataset.initialized = 'true';
  let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
  let timer;

  const showSlide = (nextIndex) => {
    activeIndex = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeIndex));
    dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
  };

  const stop = () => {
    if (timer) window.clearInterval(timer);
  };

  const start = () => {
    stop();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = window.setInterval(() => showSlide(activeIndex + 1), 6500);
    }
  };

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      showSlide(index);
      start();
    });
  });

  slideshow.addEventListener('pointerenter', stop);
  slideshow.addEventListener('pointerleave', start);
  slideshow.addEventListener('focusin', stop);
  slideshow.addEventListener('focusout', start);
  start();
}

document.querySelectorAll('[data-source-slideshow]').forEach(initSourceSlideshow);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-source-slideshow]').forEach(initSourceSlideshow);
});

const drawer = document.querySelector('[data-mobile-drawer]');
document.querySelectorAll('[data-drawer-open]').forEach((button) => {
  button.addEventListener('click', () => {
    drawer?.setAttribute('aria-hidden', 'false');
    siteHeader?.classList.add('header--menu-open');
  });
});
document.querySelectorAll('[data-drawer-close]').forEach((button) => {
  button.addEventListener('click', () => {
    drawer?.setAttribute('aria-hidden', 'true');
    siteHeader?.classList.remove('header--menu-open');
    updateHeaderState();
  });
});

document.querySelectorAll('[data-cart-open]').forEach((button) => {
  button.addEventListener('click', async () => {
    try {
      renderCart(await fetchCart());
    } catch (error) {
      console.warn(error);
    }
    openCart();
  });
});

document.querySelectorAll('[data-cart-close]').forEach((button) => {
  button.addEventListener('click', closeCart);
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form || themeSettings.cartDrawerEnabled === false) return;

  event.preventDefault();
  const button = form.querySelector('[name=add]');
  button?.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(uiText.addError);
    renderCart(await fetchCart());
    openCart();
  } catch (error) {
    console.error(error);
  } finally {
    button?.removeAttribute('aria-busy');
  }
});

document.addEventListener('click', async (event) => {
  const quantityButton = event.target.closest('[data-cart-quantity]');
  const removeButton = event.target.closest('[data-cart-remove]');
  const line = event.target.closest('.cart-line');
  const key = line?.dataset.key;

  if (quantityButton && key) {
    const input = line.querySelector('input');
    const quantity = Math.max(0, Number(input?.value || 0));
    await changeCartLine(key, quantity);
  }

  if (removeButton && key) {
    await changeCartLine(key, 0);
  }
});
